import React, { Component } from 'react';
import AuthService from '../utils/AuthService';
import Input from './Input';
import Autocomplete from './Autocomplete';

var Auth = new AuthService();

var initialBuilderInfo = {
	selectedId: null,
	selectedText: ""
};

var initialModelInfo = {
	selectedId: null,
	selectedText: ""
};

// Auth logic with routes from this example:
// https://reacttraining.com/react-router/web/example/auth-workflow
class BMYForm extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();
		this.state = {
			builderList: [],
			modelList: [],
			error: null,
			modelKey: 1,
			disableModel: true,
			disableYear: true,
		};

		this.changeYear = this.changeYear.bind(this);
		this.newChangeBuilder = this.newChangeBuilder.bind(this);
		this.newChangeModel = this.newChangeModel.bind(this);
		this.updateYear = this.updateYear.bind(this);
	}

	componentDidMount() {
		this.Auth.fetch("/pp-builders")
		.then(
			(result) => {
				if(result) {
					this.setState({
						builderList: result
					});
				} else {
					if(result.errors) {
						alert(result.errors.join("\n"));
					}
				}
			},
			(error) => {
				this.setState({
					error
				});
			}
		);
	}

	newChangeBuilder(builderInfo) {
		if(builderInfo.selectedId !== null) {
			let builderId = builderInfo.selectedId;
			this.setState({
				disableModel: true
			});
			this.Auth.fetch("/pp-model-by-builder/" + builderId)
			.then(
				(result) => {
					if(result) {
						this.setState({
							disableModel: false,
							modelKey: (this.state.modelKey + 1),
							modelList: result
						});
					} else {
						if(result.errors) {
							alert(result.errors.join("\n"));
						}
					}
				},
				(error) => {
					this.setState({
						error
					});
				}
			);
		} else if(builderInfo.selectedText !== "") {
			this.setState({
				disableModel: false,
				modelKey: (this.state.modelKey + 1)
			});
		} else {
			// both the ID and text are empty so we're not ready for model or year

			this.props.changeModel(initialModelInfo);
			this.props.changeYear("");

			this.setState({
				disableModel: true,
				disableYear: true,
				modelKey: (this.state.modelKey + 1)
			});
		}

		this.props.changeBuilder(builderInfo);
	}

	newChangeModel(modelInfo) {
		if(modelInfo.modelId !== null || modelInfo.modelName !== "") {
			this.setState({
				disableYear: false
			});
		} else {
			this.setState({
				disableYear: true
			});
		}

		this.props.changeModel(modelInfo);
	}

	changeYear(e) {
		let year = e.target.value;
		this.updateYear(year);
	}

	updateYear(year) {
		this.props.changeYear(year);
	}

	render() {
		const { builderList, modelList }= this.state;
		const { builderInfo, modelInfo, year } = this.props;

		// convert lists to option lists for select element
		let builderOptions = [];
		for(let i=0; i<builderList.length; i++) {
			builderOptions.push({
				value: builderList[i].builder_id,
				text: builderList[i].builder_name
			});
		}

		let modelOptions = [];
		for(let i=0; i<modelList.length; i++) {
			modelOptions.push({
				value: modelList[i].model_id,
				text: modelList[i].model_name
			});
		}

		// validate Year
		let digit = /^[0-9]+$/;
		let validYear = false;

		if(year.length === 4 && digit.test(year)) {
			validYear = true;
		}

		// check disable fields
		const { disableAll, isEditing, enableModelOverride, enableYearOverride } = this.props;
		let disableBuilder = disableAll;
		let disableModel = disableAll;
		let disableYear = disableAll;
		if(isEditing) {
			disableBuilder = false;
			disableModel = false;
			disableYear = false;
		} else {
			disableModel = this.state.disableModel || disableAll;
			disableYear = this.state.disableYear || disableAll;
		}

		if (enableModelOverride === true) {
			disableModel = false;
		}

		if (enableYearOverride === true) {
			disableYear = false;
		}

		return (
			<form id="bmy-form" className="pp-sizing-form">
				<div className="pp-form-wrapper">
					<h3 className="pp-form-title">Vessel Information</h3>
					<p className="pp-form-description">Required Fields*</p>

					<div className="pp-form-row">
						<Autocomplete
							label="Builder"
							htmlID="builder"
							htmlName="builder_id"
							placeholderText="Builder"
							onChange={this.newChangeBuilder}
							selectedId={builderInfo.selectedId}
							selectedText={builderInfo.selectedText}
							showListOnEmpty={false}
							options={builderOptions}
							disabled={disableBuilder}
							error={this.props.error || false}
							required
						/>
					</div>

					<div className="pp-form-row">
						<Autocomplete
							label="Model"
							htmlID="model"
							htmlName="model_id"
							placeholderText="Model"
							showListOnEmpty={true}
							onChange={this.newChangeModel}
							selectedId={modelInfo.selectedId}
							selectedText={modelInfo.selectedText}
							options={modelOptions}
							key={this.state.modelKey}
							disabled={disableModel}
							error={this.props.error || false}
							listSize="20"
							required
						/>
					</div>

					<div className={"pp-form-row" + (validYear ? '' : ' pp-invalid')}>
						<Input
							htmlID="year"
							htmlName="year"
							label="Year"
							placeholderText="YYYY"
							maxLength="4"
							value={year}
							onChange={this.changeYear}
							disabled={disableYear}
							error={this.props.error || false}
							required
						/>
					</div>
				</div>
			</form>
		);
	}
}

export default BMYForm;



// WEBPACK FOOTER //
// ./src/components/BMYForm.js